export default {
  "content": "<path d=\"M6.5 16c-1.875-.459-3.427-1.521-4.656-3.188C.614 11.145 0 9.298 0 7.271V2.5L6.5 0 13 2.5v4.771c0 2.027-.615 3.874-1.844 5.541C9.926 14.479 8.375 15.542 6.5 16zm0-1.562c1.445-.445 2.639-1.34 3.583-2.688A7.627 7.627 0 0011.5 7.271v-3.75l-5-1.917-5 1.917v3.75c0 1.639.472 3.132 1.417 4.479.944 1.347 2.138 2.243 3.583 2.688z\" fill=\"currentColor\"/><path d=\"M5.625 10.938l4.583-4.605-1.062-1.062-3.521 3.541-1.771-1.77-1.062 1.062 2.833 2.834z\" fill=\"currentColor\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "13",
    "height": "16",
    "viewBox": "0 0 13 16",
    "fill": "none"
  }
};